<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<EditEvents
			v-if="event_item"
			:color="'#81CC00'"
			:editEventItem="event_item"
			:isEdit="event_item !== null"
			@close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import EditEvents from "@/views/events/new_event.vue";

export default {
	name: 'EditEventDialogue',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: true,
			error_msg: '',

			event_id: 0,
			iteration: 1,
			event_item: null
		}
	},
	components: {
		EditEvents
	},
	created() {
		this.event_id = Number(this.$route.params.evid);
		this.iteration = Number(this.$route.query.iteration);

		this.getEvent(this.event_id, this.iteration);
	},
	methods: {
		async getEvent(id, iteration) {
			this.loading = true;

			const url = `/api/events/${id}?iteration=${iteration}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;
						this.event_item = data;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onClose() {
			window.open("/close")
		}
	}
}
</script>


